// extracted by mini-css-extract-plugin
export var button = "styles-module--button--cDZL9";
export var buttons = "styles-module--buttons--QYjmt";
export var ctaButtons = "styles-module--ctaButtons--sa7mn";
export var isCompletlyHidden = "styles-module--isCompletlyHidden--UF3Hv";
export var isSmall = "styles-module--isSmall--lHI3I";